import { IBasicActivityRecord, IPrediction, INSIGHT_FEED_TYPE } from "interfaces";

export enum E_TAB_FILTER {
    GQ = 'gq',
    BMI = 'bmi',
    MY = 'my',
    PREDICTIONS = 'predictions',
}

export enum E_TIME_FILTER {
    WEEK = 'week',
    MONTH = 'month',
    ALL = 'all',
}

export const INSIGHTS_TYPE_BY_TAB = {
    [E_TAB_FILTER.GQ]: INSIGHT_FEED_TYPE.Geoquant,
    [E_TAB_FILTER.BMI]: INSIGHT_FEED_TYPE.BMI,
    [E_TAB_FILTER.MY]: INSIGHT_FEED_TYPE.My,
};

export interface IActivitiesTab {
  list: IBasicActivityRecord[] | IPrediction[];
  activeId: string;
  hasMore: boolean;
}

export type IActivitiesMapping = {
  [key in E_TAB_FILTER]: IActivitiesTab;
}